import { getConfigurationValue }               from "dmpconnectjsapp-base/helpers/accessors";
import { canUpload, getAccessRightsProps }     from "dmpconnectjsapp-base/rules/accessRights";
import PropTypes                               from "prop-types";
import * as React                              from "react";
import { connect }                             from "react-redux";
import { setMssEmailContent, setShowMssPopup } from "../../dmpconnect/actions";
import { dmpStatuses }                         from "../../dmpconnect/constants";
import TitleTooltip                            from "../Common/TitleTooltip";
import AATButton                               from "../TLSi/AAT/AATButton";
import ALDButton                               from "../TLSi/ALD/ALDButton";
import IMTIButton                              from "../TLSi/IMTI/IMTIButton";

const DMPStatusExtraActions = ({
  ins,
  status,
  showUploadForm,
  ensRelated,
  dispatch,
  mssActive,
  lastUpdateDate,
  accessRights,
  showButtonLabels,
  insQualification,
  insQualificationManagement,
  vitaleIndex,
  vitalePatient,
  imtiActive,
  aatActive,
  aldActive,
  tlsSubSection,
  aatMode,
}) => (
  <div className="dmp-status-actions">
    {!aatMode && aldActive && tlsSubSection && <ALDButton subSection={tlsSubSection} />}
    {aatActive && <AATButton dispatch={dispatch} vitalePatient={vitalePatient} vitaleIndex={vitaleIndex} tlsSubSection={tlsSubSection}/>}
    {!aatMode && imtiActive && <IMTIButton dispatch={dispatch} vitalePatient={vitalePatient} vitaleIndex={vitaleIndex}/>}
    
    {(!!insQualification || !insQualificationManagement) && (
      <>
        {status === dmpStatuses.DMPExist && canUpload(accessRights) && (
          <>
            <TitleTooltip
              id={`upload-doc-dmp-${ins}`}
              text="Déposer un document"
              showTooltip={!showButtonLabels}
            >
              <button
                type="button"
                className={`btn btn-secondary btn-sm ${showButtonLabels ? '' : 'btn-icon-only'}`}
                onClick={() => showUploadForm(ins)}
              >
                <i className="ic-upload-document"/>
                {showButtonLabels && 'Déposer un document'}
              </button>
            </TitleTooltip>
          </>
        )}
        {!!ensRelated && !!mssActive && lastUpdateDate >= '20220101' && (
          <>
            <TitleTooltip
              id={`mss-${ins}`}
              text="Envoyer un email au patient"
              showTooltip={!showButtonLabels}
            >
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-icon-only"
                onClick={() => {
                  dispatch(setMssEmailContent({
                    recipients: `${ins.substring(0, ins.length - 1)}@patient.mssante.fr`,
                  }));
                  dispatch(setShowMssPopup(true));
                }}
              >
                <i className="ic-mon-espace-sante" style={{ fontSize: '1rem' }}/>
                {showButtonLabels && 'Envoyer un email'}
              </button>
            </TitleTooltip>
          </>
        )}
      </>
    )}
  </div>
);

DMPStatusExtraActions.propTypes = {
  dispatch                  : PropTypes.func.isRequired,
  accessRights              : PropTypes.object.isRequired,
  status                    : PropTypes.number,
  ins                       : PropTypes.string,
  showUploadForm            : PropTypes.func,
  ensRelated                : PropTypes.number,
  mssActive                 : PropTypes.bool,
  lastUpdateDate            : PropTypes.string,
  showButtonLabels          : PropTypes.bool,
  insQualification          : PropTypes.object.isRequired,
  insQualificationManagement: PropTypes.bool,
  imtiActive                : PropTypes.bool,
  aatActive                 : PropTypes.bool,
  aatMode                 : PropTypes.bool,
  tlsSubSection             : PropTypes.string,
};

DMPStatusExtraActions.defaultProps = {
  status                    : null,
  ins                       : null,
  showUploadForm            : null,
  ensRelated                : null,
  mssActive                 : false,
  lastUpdateDate            : undefined,
  showButtonLabels          : false,
  insQualificationManagement: false,
  imtiActive                : false,
  aatActive                 : false,
  aatMode                 : false,
  tlsSubSection             : '',
};

function mapStateToProps (state) {
  const { accessRights }                        = getAccessRightsProps(state);
  const { dmpConnectPersistedAppConfiguration } = state;
  return {
    accessRights,
    insQualificationManagement: getConfigurationValue('insQualificationManagement', dmpConnectPersistedAppConfiguration),
    aatMode                   : getConfigurationValue("aatMode", dmpConnectPersistedAppConfiguration)
  };
}

export default connect(mapStateToProps)(DMPStatusExtraActions);
